export default __webpack_public_path__ + "static/media/Rockwell Automation.45b05023.png";